import { NewContacts, AddContacts, Name, Age, Mobile, Save, Cancel } from '../../../../Constant';
import defaultuser from '../../../../assets/images/user/user.png';
import { Btn, Image, H6 } from '../../../../AbstractElements';
import ContactAppContext from '../../../../_helper/Contact';
import React, { Fragment, useContext, useState } from 'react';
import { Users } from 'react-feather';
import { Row, Col, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Form } from 'reactstrap';
import { useForm } from 'react-hook-form';

const CreateContact = () => {
  const [modal, setModal] = useState(false);
  const [addurl, setAddurl] = useState(defaultuser);
  const toggle = () => setModal(!modal);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(); // initialise the hook
  const { createUser } = useContext(ContactAppContext);

  const AddContact = (data) => {
    if (data !== '') {
      createUser(data, addurl);
      setModal(false);
    } else {
      errors.showMessages();
    }
  };

  const HandleAddUrl = (event) => {
    if (event.target.files.length === 0) return;
    //Image upload validation
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setAddurl(reader.result);
    };
  };

  return (
    <Fragment>
      <Btn attrBtn={{ className: `badge-light-primary align-items-center btn-mail d-flex justify-content-start w-100 emptyContact`, color: 'primery', onClick: toggle }}>
        <Users className='me-2' />
        {"Add Scheme"} 
      </Btn>
      <Modal className='modal-bookmark' isOpen={modal} toggle={toggle} size='lg'>
        <ModalHeader toggle={toggle}>{"Add Scheme"}</ModalHeader>
        <ModalBody>
          <Form className='form-bookmark needs-validation' onSubmit={handleSubmit("Add Scheme")}>
            <div className='form-row'>
              
              <FormGroup className='col-md-12'>
                <Label><H6>{"Scheme Name: "}</H6></Label>
                <Row>
                  <Col sm='6'>
                    <input className='form-control' name='omang' type='text' {...register('omang', { required: true })} />
                    <span style={{ color: 'red' }}>{errors.omang && 'Scheme name is required'}</span>
                  </Col>
                  
                </Row>
              </FormGroup> 
            
              
			  <FormGroup className='col-md-12'>
                <Label><H6>{"Scheme Eligibility: "}</H6></Label>
               
	  <select className='form-control' name="supervisor_ministry" {...register('supervisor_ministry', { required: true })}>
        <option value="ministry">Gender</option>
        <option value="departmental">Age</option>
        <option value="at_large">Salary Scale</option>
		<option value="at_large">Years of Service</option>
		<option value="at_large">Open to All Employees</option>
      </select>
	  
                <span style={{ color: 'red' }}>{errors.supervisor_ministry && 'Please select eligibility for this Scheme.'}</span>
              
			  </FormGroup>
			              
			</div>
            <Btn attrBtn={{ color: 'secondary', className: 'me-2' }}>{Save}</Btn>
            <Btn attrBtn={{ color: 'primary', onClick: toggle }}>{Cancel}</Btn>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CreateContact;
